import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

//2537B4
export default new Vuetify({
    buttons: {
        capitalize: false,
    },
    theme: {
        themes: {
            light: {
                primary: '#2537B4'
            }
        },
    },
});
